var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"6","width":"32","height":"2","rx":"1","fill":"#0E5642","key":0}),React.createElement("rect",{"x":"7.4668","y":"14.5332","width":"24.5333","height":"2","rx":"1","fill":"#0E5642","key":1}),React.createElement("rect",{"x":"3.2002","y":"23.0664","width":"28.8","height":"2","rx":"1","fill":"#0E5642","key":2})]);
}

Hamburger.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","aria-hidden":"true"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
